//@ts-nocheck
import { Card, CardBody, Col, UncontrolledAccordion } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineAccordions } from "../../../../Constant";
import { OUTLINE_DATA, OUTLINE_LIST } from "../../../../Data/UiKit/Accordion";
import CommonAccordionItem from "../Common/CommonAccordionItem";
import { StaticAccordion } from "./StaticAccordion";

const OutlineAccordion = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={OutlineAccordions} span={OUTLINE_DATA} />
        <CardBody className="accordion-border">
          <UncontrolledAccordion stayOpen className="dark-accordion">
            <StaticAccordion/>
            {OUTLINE_LIST.map((data, index) => (
              <CommonAccordionItem item={data} key={index} />
            ))}
          </UncontrolledAccordion>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OutlineAccordion;
